<template><!--充值协议-->
  <div class="recharge">

    <div style="text-align: center; margin: 20px 0;">
      <h2>充值协议</h2>
    </div>

    <div>
      感谢您使用陌撩币服务。陌撩币购买协议（以下简称“本协议”）由睢宁陌撩信息科技有限公司（以下简称“陌撩漂流瓶”）和您签订。
    </div>

    <h3> 一、陌撩币购买协议的确认</h3>
    <div>
      <p>
        1.陌撩漂流瓶在此特别提醒您在使用陌撩币服务之前，请认真阅读本协议，确保您充分理解本协议项下各条款的含义。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您无权使用陌撩币服务。您的使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
      </p>
      <p>
        2.本协议可由陌撩漂流瓶随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在陌撩漂流瓶查阅最新版协议条款。在陌撩漂流瓶修改协议条款后，如果用户不接受修改后的条款，请立即停止使用陌撩币服务，用户继续使用陌撩币服务将被视为接受修改后的协议。
      </p>
      <p>
        3.如您为无民事行为能力人或限制民事行为能力人，请告知您的监护人，并在您监护人的指导下阅读本协议，在监护人同意的前提下使用陌撩币服务。
      </p>
    </div>

    <h3> 二、陌撩币服务相关定义</h3>
    <div>
      <p>
        1.陌撩漂流瓶号：指您按照陌撩漂流瓶《用户协议》规定的方式取得的、供您登陆陌撩漂流瓶并使用部分陌撩漂流瓶服务的号码。</p>
      <p>
        2.陌撩币账户（或称“账户”）：指您使用陌撩漂流瓶号登陆陌撩漂流瓶并同意本协议后获得的、以您使用陌撩漂流瓶服务向陌撩漂流瓶支付虚拟礼物价款为目的的账户。您取得陌撩币账户后，陌撩漂流瓶号即成为您陌撩币账户账号。
      </p>
      <p>
        3.商品或服务：目前仅指陌撩漂流瓶平台上不同种类的虚拟礼物服务。
      </p>
      <p>
        4.账户余额：指您为了购买陌撩漂流瓶的商品或服务事先向陌撩漂流瓶支付的可以用于抵扣陌撩漂流瓶商品或服务对价款的款项数额。
      </p>
      <p>
        5.身份要素：指陌撩漂流瓶用于识别您身份的信息要素，包括但不限于您的陌撩漂流瓶号、手机号、陌撩币账户、短信校验码、身份证件号码等。
      </p>
      <p>
        6.陌撩漂流瓶：除本协议另有规定外，指“陌撩漂流瓶”移动应用软件。
      </p>
      <p>
        7.有权机关：指依照法律法规等有权要求查询、冻结或扣划资金等措施的单位，包括但不限于公安机关、检察院、法院、海关、税务机关。
      </p>
      <p>
        8.冻结：指有权机关要求的冻结。被冻结余额不能用于支付或送礼物等，被冻结账户不可登录、使用。
      </p>
      <p>
        9.限制：指除冻结情况之外，陌撩币账户的部分或全部功能不能使用，陌撩币账户余额不能使用。
      </p>
      <p>
        10.止付：限制措施的一种，指陌撩币账户余额不能使用，例如不能用于支付或送礼物等服务。
      </p>
    </div>

    <h3> 三、陌撩币服务内容</h3>
    <div>
      <p>
        1.购买服务，您可以为了方便您在未来任意时间购买陌撩漂流瓶的商品或服务，您可以使用银行卡或第三方支付平台支付账户内的资金购买陌撩币。
      </p>
      <p>
        2.支付服务，您可以用您陌撩币账户余额中的同等数额抵扣未来任意时间您向陌撩漂流瓶购买商品或服务时应向陌撩漂流瓶支付的对价款。抵扣成功后，您陌撩币账户内的余额将被相应扣减。
      </p>
    </div>

    <h3> 四、 陌撩币账户的注册和使用</h3>
    <div>
      <p> 1.注册
        <br> 您完成陌撩漂流瓶号注册并激活后，即可使用部分陌撩漂流瓶服务；您还可以进一步申请并通过陌撩漂流瓶验证后，使用陌撩币服务。具体验证方式以陌撩漂流瓶内的提示为准。
      </p>
      <p> 2.使用
        <br>
        身份要素是陌撩漂流瓶识别您身份的依据，请您务必妥善保管。使用身份要素进行的任何操作、发出的任何指令均视为您本人做出。因您的原因造成的账户、密码等信息被冒用、盗用或非法使用，由此引起的一切风险、责任、损失、费用等应由您自行承担。您同意：
        <br> 1.基于不同的终端以及您的使用习惯，陌撩漂流瓶可能采取不同的验证措施识别您的身份。例如您的陌撩币账户在新设备首次登录的，陌撩漂流瓶可能通过密码加校验码的方式识别您的身份。
        <br>
        2.为保障您的账户余额安全，请把手机及其他设备的密码设置成与陌撩漂流瓶号及陌撩币账户的密码不一致。如您发现有他人冒用或盗用您的陌撩漂流瓶号或者陌撩币账户密码，或您的手机或其他有关设备丢失时，请您立即以有效方式通知陌撩漂流瓶。
        <br> 3.陌撩漂流瓶号及陌撩币账户账号仅限您本人使用，不可转让、借用、赠与、继承，但陌撩币账户内的相关财产权益可被依法继承。
        <br> 4.基于运行和交易安全的需要，陌撩漂流瓶可以暂停或者限制陌撩漂流瓶服务部分功能，或增加新的功能。
      </p>
    </div>

    <h3> 五、 使用陌撩币服务的注意事项</h3>
    <div>
      <p>
        1.身份验证
        <br>
        您在使用陌撩币服务过程中，特别是当您购买陌撩币或支出数额较大时，为了确保您的合法权益并确保您的行为符合国家相关法律法规，陌撩漂流瓶有权要求您提供合法、真实、有效及完整的资料（包括但不限于身份证、绑定银行卡、绑定经验证的第三方支付平台支付账户、户口本、护照、营业执照、开户许可证等证明、联系方式、从事职业、通讯地址）对您进行身份认证。为了及时有效地验证您的信息（包括但不限于身份信息、银行账户信息等），根据法律法规及监管规定或陌撩漂流瓶认为有需要时，您同意我们可以把您的信息提供给第三方，也同意第三方可以把您的信息提供给陌撩漂流瓶，以便陌撩漂流瓶进行验证。您应确保陌撩漂流瓶号及陌撩漂流瓶号绑定的电子邮箱、手机号和第三方支付平台支付账户均为您本人合法所有。
      </p>
      <p>
        2.存在如下情形时，陌撩漂流瓶会对您名下的陌撩币账户或对余额进行止付，且有权限制您所使用的产品或服务功能：
        <br> 1.您违反了本协议、用户协议及相关行为规范的约定；
        <br> 2.根据法律法规及法律文书的规定；
        <br> 3.根据有权机关的要求；
        <br> 4.您的陌撩币账户操作、余额流向等存在异常时；您的陌撩币账户可能产生风险的；
        <br> 5.您遭到他人投诉，且对方已经提供了一定证据的；
        <br> 6.您可能错误地操作他人陌撩漂流瓶号或陌撩币账户，或者将陌撩漂流瓶号或陌撩币账户进行了身份验证的。
        除（2）、（3）规定的情形外，如您申请恢复服务、解除上述止付或限制，请您向陌撩漂流瓶提供相关资料及身份证明等文件，以便陌撩漂流瓶进行核实。
        如陌撩漂流瓶依据上述（1）、（2）、或（3）规定的情形将您的陌撩漂流瓶号或陌撩币账户永久封禁，您可以通过陌撩漂流瓶的“反馈与建议”界面发起退款，但涉及违反法律规定的情形，陌撩漂流瓶不予退款。
      </p>
    </div>

    <h3> 六、陌撩币服务规则</h3>
    <div>
      <p>
        1.您认可您陌撩币账户内余额的使用记录、交易数据等均以陌撩漂流瓶系统记录为准。如您对该等数据存有异议的，可及时向陌撩漂流瓶提出异议，并提供相关证据供陌撩漂流瓶核实。
      </p>
      <p>
        2.陌撩币和人民币的兑换比例以用户购买陌撩币的服务页面显示为准。陌撩漂流瓶有权根据运营情况变更兑换比例，并在用户购买陌撩币的服务页面显示。
      </p>
      <p>
        3.您在使用陌撩币服务过程中，本协议内容、陌撩漂流瓶上出现的关于操作的提示或陌撩漂流瓶发送到手机的信息内容是您使用陌撩币服务的相关规则。
      </p>
      <p>
        4.陌撩漂流瓶会以平台内公告、电子邮件、发送短信、电话、站内信或客户端通知等方式向您发送通知，例如通知您购买陌撩币成功或抵扣进展情况，或者提示您进行相关操作，请您及时予以关注。
      </p>
      <p>
        5.您应自行承担您使用陌撩币服务期间的任何货币贬值的风险。
      </p>
    </div>

    <h3> 七、用户合法使用陌撩币服务的承诺</h3>
    <div>
      <p>
        1.您应遵守中华人民共和国相关法律法规及您所属、所居住或开展经营活动或其他业务的国家或地区的法律法规，不得将陌撩币服务用于任何非法目的（包括洗钱等非法活动），也不得以任何非法方式使用陌撩币服务。
      </p>
      <p>
        2.您不得利用陌撩币服务从事侵害他人合法权益之行为，否则陌撩漂流瓶有权进行调查、延迟结算或拒绝提供陌撩币服务，且您应承担所有相关法律责任，因此导致陌撩漂流瓶或其他方受损的，您应承担赔偿责任。
      </p>
      <p>
        3.上述1和2适用的情况包括但不限于：侵害他人名誉权、隐私权、商业秘密、商标权、著作权、专利权等合法权益。
        <br> a.违反依法定或约定之保密义务。
        <br> b.冒用他人名义使用陌撩币服务。
        <br> c.从事不法交易行为， 如洗钱、恐怖融资、贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品、其他陌撩漂流瓶认为不得使用陌撩币服务进行交易的物品等。
        <br> d.提供赌博资讯或以任何方式引诱他人参与赌博。
        <br> e.从事任何可能侵害陌撩币服务系统、数据之行为。
      </p>
      <p>
        4.您理解，陌撩币服务有赖于系统的准确运行及操作。若出现系统差错、故障或其他原因引发的展示错误、您或陌撩漂流瓶不当获利等情形，您同意陌撩漂流瓶可以采取更正差错、扣划款项等适当纠正措施。
      </p>
      <p>
        5.如果用户使用他人代充或以其他违规方式购买造成其他用户或第三方权益受损时，不得因此要求陌撩漂流瓶作任何补偿或赔偿，陌撩漂流瓶保留随时冻结其账户余额、暂停或终止其使用各项购买服务及禁用其账户的权利。如陌撩漂流瓶有理由相信用户的陌撩币帐户或使用情况涉及违规代购买、作弊或异常状况，陌撩漂流瓶有权拒绝该用户继续使用陌撩币，并按本协议、用户协议及相关规范采取冻结、禁用账户等相关措施。
      </p>
    </div>

    <h3>
      八、陌撩币一经购买成功，除法律法规明确规定外，在任何情况下不能兑换为法定货币，不能转让他人。用户间交易陌撩币构成对本协议的违反，陌撩漂流瓶有权不通知用户而采取适当措施，以确保陌撩漂流瓶不为违规用户提供陌撩币交易的平台服务。陌撩币不支持提现功能。
    </h3>

    <h3> 九、权益保障及隐私保护</h3>
    <div>
      <p>
        1.用户账户余额安全保障
        <br>
        陌撩漂流瓶始终重视保护用户的账户余额安全，将自有资金和用户账户余额分开存放，承诺不挪用、占用用户账户余额。如您在使用陌撩币服务过程中，由于您的陌撩币账户或密码被盗用造成的账户余额损失，经陌撩漂流瓶同意，您可授权陌撩漂流瓶代表您向相关责任第三方或赔付机构进行追偿。
      </p>
      <p>
        2.用户权益及隐私权保护
        <br> 陌撩漂流瓶重视对用户合法权益的保障和隐私的保护。关于您的身份资料和其他特定资料依陌撩漂流瓶《用户协议》受到保护与规范，您的合法权益陌撩漂流瓶承诺按陌撩漂流瓶《用户协议》及本协议的相关约定给予保障。
      </p>
    </div>

    <h3> 十、不可抗力、免责</h3>
    <div>
      因下列原因导致陌撩漂流瓶无法正常提供服务，陌撩漂流瓶不承担任何责任：
      <br> 1.陌撩漂流瓶系统停机维护或升级；
      <br> 2.因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；
      <br> 3.用户的手机等移动通信终端软硬件和通信线路、供电线路出现故障的；
      <br> 4.用户操作不当或通过非陌撩漂流瓶授权或认可的方式使用陌撩币服务的；
      <br> 5.因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因 、第三方服务瑕疵或政府行为等原因。
      <br> 6.尽管有前述约定，陌撩漂流瓶将采取合理行动积极促使服务恢复正常。
    </div>

    <h3> 十一、完整协议</h3>
    <div>
      陌撩漂流瓶《用户协议》与陌撩漂流瓶平台不时公示的各项规则对相关事项有约定，而本协议条款没有约定的，以各项规则约定为准。本协议部分内容被有管辖权的法院认定为违法或无效的，不影响其他内容的效力。
    </div>

    <h3> 十二、知识产权的保护</h3>
    <div>
      <p>
        1.陌撩漂流瓶及关联公司所有系统及本陌撩漂流瓶平台上所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计，均由陌撩漂流瓶或陌撩漂流瓶关联公司依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。
      </p>
      <p>
        2.非经陌撩漂流瓶或陌撩漂流瓶联公司书面同意，任何人不得擅自使用、修改、反向编译、复制、公开传播、改变、散布、发行或公开发表本网站程序或内容。
      </p>
      <p>
        3.尊重知识产权是您应尽的义务，如有违反，您应依法承担损害赔偿责任。
      </p>
    </div>
    <h3> 十三、 法律适用与管辖</h3>
    <div>
      本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，均应依照中华人民共和国法律予以处理，并由陌撩漂流瓶所在地人民法院管辖。
    </div>

    <br>
    <br>
    <br>

  </div>
</template>


<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {

  }
}
</script>

<style>
.recharge {
  width: 92%;
  max-width: 960px;
  margin: auto;
  font-size: 14px;
  line-height: 26px;
}

.recharge div{
  margin-bottom: 8px;
}

.recharge h3 {
  margin: 8px 0;
}

p {
  margin: 4px 0;
}

</style>
